import React from 'react';
import tennesseeMap from 'assets/graphics/tennessee.svg';
import 'sections/styles/ServiceAreaSection.css';
import { serviceCounties } from 'data';

const ServiceAreaSection: React.FC = () => {


	return (
		<section className="service-area">
			<div className="container">
				<div className="service-area__header">
					<h2 className="service-area__title">Our Service Area</h2>
					<p className="service-area__subtitle">
						We proudly serve Knoxville, Tennessee and the surrounding counties. If you're in one of these counties, let's talk!
					</p>
				</div>

				<div className="service-area__content">
					<div className="service-area__counties">
						<ul className="service-area__counties-list">
							{serviceCounties.map((county, index) => (
								<li key={county} className="service-area__county-item" style={{ animationDelay: `${index * 0.1}s` }}>
									<span className="service-area__county-icon"></span>
									<span className="service-area__county-name">{county}</span>
								</li>
							))}
						</ul>
						{/* <p className="service-area__disclaimer">
							Don't see your county? Contact us—we may be able to work something out!
						</p> */}
					</div>
				</div>
			</div>
		</section>
	);
};

export default ServiceAreaSection;
